export const SAVE_NOTES_REQUEST = "SAVE_NOTES_REQUEST";
export const SAVE_NOTES_SUCCESS = "SAVE_NOTES_SUCCESS";
export const SAVE_NOTES_ERROR = "SAVE_NOTES_ERROR";
